'use strict';

var _ = require('lodash');
var PooledSeasonalityInputChartDataRetrieverService = function PooledSeasonalityInputChartDataRetrieverService($q, restangular, pooledReviewCalendarService, seasonalityReviewConstants, momentService, seasonColorService, configurationService, chartHelper, dataTransformationService) {
  function getInputChartData(flowType, calendarData, filterData) {
    return $q.all([getIndexProfiles(flowType, filterData, calendarData), fetchCabinOutliers(flowType, filterData, calendarData)]);
  }
  function getIndexProfiles(flowType, filterData, calendarData) {
    var market = calendarData.market.split('-');
    var usableDow = pooledReviewCalendarService.getUsableDowGroup(filterData.selectedDow);
    var profileType = chartHelper.getProfileName(flowType, seasonalityReviewConstants.PROFILE_TYPE.INDEX);
    var calendarFilter;
    var filters = {
      origin: market[0],
      destination: market[1],
      cabin: filterData.selectedCabin,
      significantPOS: filterData.significantPOS,
      dowGroup: usableDow,
      daysToDeparture: filterData.selectedRtp
    };
    if (chartHelper.isProfileInactiveOrPublishing(calendarData)) {
      calendarFilter = calendarData.calendarName;
    } else {
      filters.scenarioName = chartHelper.getScenarioName(calendarData);
    }
    return pooledReviewCalendarService.fetchHepProfiles(profileType, filters, undefined, calendarFilter);
  }
  function fetchCabinOutliers(flowType, filterData, calendarData) {
    var market = calendarData.market.split('-');
    var cabin = filterData.selectedCabin;
    var startDate = calendarData.startDepartureDate;
    var endDate = calendarData.endDepartureDate;
    var filter = {
      origin: market[0],
      destination: market[1],
      cabin: cabin,
      significantPOS: filterData.significantPOS,
      departureDate: [startDate, endDate]
    };
    var localFilter = flowType === seasonalityReviewConstants.FLOW_TYPE.REGULAR ? {
      attribute: 'isRegularOutlier'
    } : {
      attribute: 'isMappedOutlier'
    };
    return pooledReviewCalendarService.getMarketCabinOutliers(filter, localFilter);
  }
  function transformData(dataset, calendarData, filterData) {
    var indexProfiles = dataset[0];
    if (indexProfiles.length < 1) {
      return {
        chartData: [],
        simpleLegend: [],
        staticLegend: [],
        legend: []
      };
    }
    var outliers = dataset[1];
    var dowFilter = pooledReviewCalendarService.getDayOfWeek(filterData.selectedDow);
    var dowDepartureDates = chartHelper.getDepartureDatesPerDoW(calendarData, dowFilter, outliers);
    var woyIndices = dataTransformationService.getWoyIndices(indexProfiles);
    return constructChartData(dowDepartureDates, woyIndices, getEventColorMap(calendarData), filterData.significantPOS);
  }
  function constructChartData(dowDepartureDates, woyIndices, eventColorMap, spos) {
    var chartAttributes = {
      simpleLegend: chartHelper.getSimpleLegend(),
      staticLegend: chartHelper.getStaticLegend(),
      legend: [],
      chartData: []
    };
    chartAttributes.chartData = _.reduce(dowDepartureDates, function (chartData, dateObj) {
      var woy = dateObj.date.isoWeekOfYear() === seasonalityReviewConstants.WOY_53 ? 1 : dateObj.date.isoWeekOfYear();
      var woyIndex = _.get(woyIndices, woy);
      var originRemaningResHold = woyIndex.originalRemainingUntruncatedResHold;
      var effectiveRemainingResHold = woyIndex.effectiveRemainingUntruncatedResHold;
      var noData = _.isUndefined(originRemaningResHold) && _.isUndefined(effectiveRemainingResHold);
      var data = {
        d1: dateObj.date,
        eventType: dateObj.eventType,
        excluded: false,
        isGap: noData,
        o1: 0,
        tiles: [],
        spos: spos
      };
      if (!noData) {
        data.stackLabel = dateObj.eventName;
        data.m1 = originRemaningResHold || 0;
        data.m2 = effectiveRemainingResHold || 0;
        var eventColors = _.get(eventColorMap, dateObj.eventName);
        if (dateObj.eventType !== seasonalityReviewConstants.EVENT_TYPE.EXCLUDED) {
          data.m1fill = eventColors.dark;
          data.m2fill = eventColors.light;
          data.tiles = originRemaningResHold && effectiveRemainingResHold && originRemaningResHold > effectiveRemainingResHold ? [{
            m2: data.m2,
            fill: data.m2fill
          }] : [];
        }
        if (isExcluded(dateObj)) {
          data.overlay = 'user-exclusion';
          data.overlayViewport = 'user-exclusion-viewport';
          data.excluded = true;
          data.o1 = data.m1 > data.m2 ? data.m1 : data.m2;
          data.isRegularOutlier = dateObj.isRegularOutlier || false;
          data.isMappedOutlier = dateObj.isMappedOutlier || false;
        }
      }
      return chartData.concat(data);
    }, []);
    buildChartLegends(eventColorMap, chartAttributes);
    return chartAttributes;
  }
  function buildChartLegends(eventColorMap, chartAttributes) {
    chartAttributes.legend = _.chain(eventColorMap).keys(eventColorMap).filter(function (eventName) {
      return eventName !== seasonalityReviewConstants.EVENT_TYPE.NO_EVENT;
    }).reduce(function (legends, eventName) {
      return legends.concat({
        label: eventName,
        fill: _.get(eventColorMap, eventName).dark
      });
    }, []).value();
    if (chartAttributes.legend.length < 2) {
      chartAttributes.simpleLegend = _.union(chartAttributes.simpleLegend, chartAttributes.legend, chartAttributes.staticLegend);
      chartAttributes.simpleLegend.push(chartHelper.getDefaultLegend());
      chartAttributes.staticLegend = [];
      chartAttributes.legend = [];
    } else {
      chartAttributes.legend.push(chartHelper.getDefaultLegend());
    }
  }
  function getEventColorMap(calendarData) {
    var specialEvents = calendarData.specialEvents;
    var colorMap = {
      normal: {
        dark: seasonalityReviewConstants.COLOR_THEME.FILL_DARK,
        light: seasonalityReviewConstants.COLOR_THEME.FILL_LIGHT
      }
    };
    if (_.isArray(specialEvents) && specialEvents.length > 0) {
      _.forEach(specialEvents, function (event) {
        if (event.eventType !== seasonalityReviewConstants.EVENT_TYPE.EXCLUDED) {
          _.set(colorMap, event.eventName, seasonColorService.getColor(event.eventName, 20));
        }
      });
    }
    return colorMap;
  }
  function isExcluded(dateObj) {
    return dateObj.eventType === seasonalityReviewConstants.EVENT_TYPE.EXCLUDED || dateObj.eventType === seasonalityReviewConstants.EVENT_TYPE.OUTLIER;
  }
  function saveOutliers(market, selectedBars, cabins, dowGroup) {
    var carrier = configurationService.getHostCarrier();
    var outlierDocs = dataTransformationService.barsToOutlierDoc(carrier, market, selectedBars, cabins, dowGroup);
    var partitions = _.chunk(outlierDocs, seasonalityReviewConstants.OUTLIER_PARTITION_SIZE);
    var promises = [];
    _.forEach(partitions, function (partition) {
      promises.push(pooledReviewCalendarService.saveOutliersToDB(partition));
    });
    return $q.all(promises);
  }
  return {
    getInputChartData: getInputChartData,
    transformData: transformData,
    saveOutliers: saveOutliers
  };
};
PooledSeasonalityInputChartDataRetrieverService.$inject = ['$q', 'Restangular', 'PooledReviewCalendarService', 'PooledSeasonalityReviewConstants', 'MomentService', 'SeasonColorService', 'ConfigurationService', 'PooledSeasonalityChartsHelper', 'PooledSeasonalityChartDataTransformationService'];
module.exports = PooledSeasonalityInputChartDataRetrieverService;